module.exports = __webpack_public_path__ + "img/emotion-neutral.7487fc8a.svg";